package com.merkost.handpass.sharedweb.theme

import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import kotlin.js.unsafeCast

object HandpassColors {
    val Primary get() = Accent.value().toString()
    val PrimaryHover get() = AccentHover.value().toString()
    val PrimaryPressed get() = AccentPressed.value().toString()
    val PrimaryText get() = AccentText.value().toString()
    val PrimarySoft get() = AccentSoft.value().toString()
    val Action get() = ActionAccent.value().toString()
    val ActionHover get() = ActionAccentHover.value().toString()
    val ActionPressed get() = ActionAccentPressed.value().toString()
    val TextOnAction get() = OnActionAccent.value().toString()
    val TextOnBrandAction get() = OnBrandActionAccent.value().toString()
    val Background get() = Bg.value().toString()
    val Surface get() = com.merkost.handpass.sharedweb.theme.Surface.value().toString()
    val SurfaceElevated get() = com.merkost.handpass.sharedweb.theme.Surface.value().toString()
    val SurfaceMuted get() = com.merkost.handpass.sharedweb.theme.SurfaceMuted.value().toString()
    val TextPrimary get() = OnSurface.value().toString()
    val TextSecondary get() = OnSurfaceMuted.value().toString()
    val TextMuted get() = OnSurfaceFaint.value().toString()
    val TextOnPrimary get() = OnAccent.value().toString()
    val Border get() = com.merkost.handpass.sharedweb.theme.Border.value().toString()
    val RowHover get() = com.merkost.handpass.sharedweb.theme.RowHover.value().toString()
    val BorderHover get() = BorderStrong.value().toString()
    val BorderFocus get() = Accent.value().toString()
    val Success get() = com.merkost.handpass.sharedweb.theme.Success.value().toString()
    val SuccessSoft get() = com.merkost.handpass.sharedweb.theme.SuccessSoft.value().toString()
    val Error get() = Danger.value().toString()
    val ErrorSoft get() = DangerSoft.value().toString()
    val Warning get() = com.merkost.handpass.sharedweb.theme.Warning.value().toString()
    val WarningSoft get() = com.merkost.handpass.sharedweb.theme.WarningSoft.value().toString()
    val Info get() = com.merkost.handpass.sharedweb.theme.Info.value().toString()
    val InfoSoft get() = com.merkost.handpass.sharedweb.theme.InfoSoft.value().toString()
    val RatingStar get() = com.merkost.handpass.sharedweb.theme.RatingStar.value().toString()
    val Ink get() = FixedInk.value().toString()
    val OnInk get() = FixedOnInk.value().toString()
    val Transparent get() = com.merkost.handpass.sharedweb.theme.Transparent.value().toString()
    val OverlayLight get() = com.merkost.handpass.sharedweb.theme.OverlayLight.value().toString()
    val OverlayMedium get() = Overlay.value().toString()
    val OverlayHeavy get() = com.merkost.handpass.sharedweb.theme.OverlayHeavy.value().toString()
}

object HandpassSpacing {
    val XXS get(): CSSSizeValue<CSSUnit.px> = SpaceXxs.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val XS get(): CSSSizeValue<CSSUnit.px> = SpaceXs.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val SM get(): CSSSizeValue<CSSUnit.px> = SpaceSm.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val MD get(): CSSSizeValue<CSSUnit.px> = SpaceMd.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val Default get(): CSSSizeValue<CSSUnit.px> = SpaceDefault.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val LG get(): CSSSizeValue<CSSUnit.px> = SpaceLg.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val XL get(): CSSSizeValue<CSSUnit.px> = SpaceXl.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val XXL get(): CSSSizeValue<CSSUnit.px> = SpaceXxl.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
    val XXXL get(): CSSSizeValue<CSSUnit.px> = SpaceXxxl.value().unsafeCast<CSSSizeValue<CSSUnit.px>>()
}

object HandpassRadius {
    val XS get() = RadiusXs.value()
    val SM get() = RadiusSm.value()
    val MD get() = RadiusMd.value()
    val Card get() = RadiusCard.value()
    val Thumb get() = RadiusThumb.value()
    val LG get() = RadiusLg.value()
    val Pill get() = RadiusPill.value()
    val Full get() = RadiusFull.value().toString()
}

object HandpassTypography {
    val FontFamily get() = FontSans.value()
    val DisplayFamily get() = FontDisplay.value()
    val MonoFamily get() = FontMono.value()
    val XS get() = TypeXs.value()
    val SM get() = TypeSm.value()
    val Caption get() = TypeCaption.value()
    val Body get() = TypeBody.value()
    val MD get() = TypeMd.value()
    val LG get() = TypeLg.value()
    val Title get() = TypeTitle.value()
    val XL get() = TypeXl.value()
    val StatNumber get() = TypeStat.value()
    val XXL get() = TypeXxl.value()
    val Hero get() = TypeHero.value()
}

object HandpassShadows {
    val Card get() = ShadowCard.value()
    val CardHover get() = ShadowCardHover.value()
    val Dropdown get() = ShadowDropdown.value()
    val Modal get() = ShadowModal.value()
}

object HandpassLayout {
    val MaxWidth get() = LayoutMaxWidth.value()
    val MaxWidthWide get() = LayoutMaxWidthWide.value()
    val HeaderHeight get() = LayoutHeaderHeight.value()
    val HeaderRowMobile get() = LayoutHeaderRowMobile.value()
    val HeaderSearchRowMobile get() = LayoutHeaderSearchRowMobile.value()
    const val Mobile = WebBreakpoint.Mobile
    const val Tablet = WebBreakpoint.Tablet
    const val Desktop = WebBreakpoint.Desktop
    const val Wide = WebBreakpoint.Wide
}
